import React from 'react';
import moment from "moment";
import { DatePicker } from 'antd';

const { RangePicker } = DatePicker;

interface props {
  onChange?: any,
  value?: any,
  style?: any,
  startName?: any,
  endName?: any,
  disabledDate?: any,
  onCalendarChange?: any,
  showTime?: any
  format?: any,
  disabledTime?: any,
  allowClear?: any,
  needSeconds?: boolean,
  paramType?: 'array',
  minuteStep?:any
}

const SPRangePicker: React.FC<props> = (props) => {
  const { onChange, value, format = 'YYYY-MM-DD', style, needSeconds, paramType,
    startName = 'start_time', endName = 'end_time', disabledDate,onCalendarChange, showTime, disabledTime,minuteStep
  } = props

  const getDefaultValue: any = (dates: any) => {
    if(!dates) return [undefined, undefined];

    let start: any = paramType === 'array' ? dates[0] : dates[startName],
        end: any = paramType === 'array' ? dates[1] : dates[endName];

    if(moment(start, format).isValid() && moment(end, format).isValid()){
      return [moment(start, format), moment(end, format)];
    }else{
      return [undefined, undefined]
    }

  };

  const onMoment = (dates: any, dateStrings: any) => {
    if(!dates) return onChange(null);

    let val: any = {};

    if(moment(dates[0], format).isValid() && moment(dates[1], format).isValid()){
      const startTime = needSeconds ? moment(dates[0]).unix() : moment(dates[0]).format(format);
      const endTime = needSeconds ? moment(dates[1]).unix() : moment(dates[1]).format(format);
      if (paramType === 'array') {
        val = [];
        val[0] = startTime
        val[1] = endTime
      } else {
        val[startName] = startTime;
        val[endName] = endTime;
      }
    } else {
      return onChange(null);
    }
    onChange(val);
  };

  return (
    <RangePicker style={style} format={format} defaultValue={getDefaultValue(value)} onChange={onMoment} disabledDate={disabledDate} disabledTime={disabledTime} onCalendarChange={onCalendarChange} inputReadOnly showTime={showTime} allowClear minuteStep={minuteStep} />
  );
};

export default SPRangePicker;

